// @flow
import { reduxForm } from 'redux-form'
import { withRouter } from 'react-router-dom'
import { compose, withProps } from 'recompose'
import { t } from '../../core/i18n'
import Login from '../../ui/forms/login-form'
import { login } from './actions'
import { validateEmail, validateRequired } from '../validations/validations'

const form = reduxForm({
  form: 'login',
  validate: values => ({
    email: validateEmail(values.email),
    password: validateRequired(values.password)
  }),
  onSubmit(values, dispatch, props) {
    const history = props.history
    const location = props.location
    return dispatch(login(values)).then(success => {
      const returnUrl = location.state && location.state.returnUrl
      console.log('return url?', returnUrl)
      if (returnUrl) {
        history.replace(returnUrl)
      } else {
        history.replace('/explore')
      }
    })
  }
})

const withTranslations = withProps(props => ({
  translations: {
    emailLabel: t('app:forms.field.email.label'),
    passwordLabel: t('app:forms.field.password.label'),
    logInButton: t('app:button.logIn'),
    forgotPasswordText: t('app:login.forgotPassword'),
    faceBookSignInButton: t('app:button.facebookSignIn'),
    noAccountText: t('app:login.noAccount'),
    signUp: t('common:signUp')
  }
}))

export const decorate = compose(withRouter, form, withTranslations)

export default decorate(Login)



// WEBPACK FOOTER //
// ./src/services/session/login-form.js